import React from "react";

import { BaseHero } from "../../common";
import { Styles, withStyles } from "./styles";

export const StackedLayoutBase: React.FC<Styles> = ({ classes, children }) => (
  <>
    <BaseHero className={classes.hero}>{children}</BaseHero>
    <div className={classes.selectorContainerPadding} />
  </>
);

export const StackedLayout = withStyles(StackedLayoutBase);
